/*
* Single source of truth
* Base of routes to use with gateway API
* */
export default {
  INTERACTIONS_LIST_ROUTE:          `${process.env.GATEWAY_V2_END_POINT}/interactions.v2.list`,
  INTERACTIONS_INFO_ROUTE:          `${process.env.GATEWAY_END_POINT}/interactions.v2.info`,
  INTERACTIONS_COUNTERS_LIST_ROUTE: `${process.env.GATEWAY_END_POINT}/interactions.counters.list`,
  ACTIVITIES_LIST_ROUTE:            `${process.env.GATEWAY_V2_END_POINT}/activities.list`,
  ACTIVITIES_LIST_ALL_ROUTE:        `${process.env.GATEWAY_V2_END_POINT}/activities.list.all`,
  ACTIVITIES_DATES:                 `${process.env.GATEWAY_V2_END_POINT}/activities.dates`,
  //inboxes routes
  INBOXES_LIST_ROUTE:               `${process.env.GATEWAY_END_POINT}/inboxes.list`,
  INBOXES_SETTINGS_SAVE_ROUTE:      `${process.env.GATEWAY_END_POINT}/inboxes.settings.save`,
  INBOXES_SETTINGS_OPTIONS_ROUTE:   `${process.env.GATEWAY_END_POINT}/inboxes.settings.options`,
  //trigger events routes
  TRIGGER_EVENT_FIND_ROUTE:         `${process.env.GATEWAY_END_POINT}/trigger.find.events`,
  TRIGGER_EVENT_ROUTE:              `${process.env.GATEWAY_END_POINT}/trigger.event`,
  //pauses routes
  PAUSES_LIST_ROUTE:                `${process.env.GATEWAY_END_POINT}/pauses.list`,
  PAUSE_REMOVE_ROUTE:               `${process.env.GATEWAY_END_POINT}/pauses.remove`,
  PAUSE_SAVE_ROUTE:                 `${process.env.GATEWAY_END_POINT}/pauses.save`,
  //interaction action routes
  INTERACTIONS_REMOVE_ROUTE:        `${process.env.GATEWAY_END_POINT}/interactions.remove`,
  INTERACTIONS_ARCHIVE_ROUTE:       `${process.env.GATEWAY_END_POINT}/interactions.archive`,
  INTERACTIONS_UNARCHIVE_ROUTE:     `${process.env.GATEWAY_END_POINT}/interactions.unarchive`,
  INTERACTIONS_ASSIGN_ROUTE:        `${process.env.GATEWAY_END_POINT}/interactions.assign`,
  INTERACTIONS_UNASSIGN_ROUTE:      `${process.env.GATEWAY_END_POINT}/interactions.unassign`,
  //general routes
  PROFILE_ROUTE:                    `${process.env.GATEWAY_V2_END_POINT}/profile.self`,
  SOCKET_INFO_ROUTE:                `${process.env.GATEWAY_END_POINT}/socket.info.chatapp`,
  GENERAL_SOCKET_INFO_ROUTE:         `${process.env.GATEWAY_END_POINT}/socket.info`,
  ORGANISATION_INFO_ROUTE:          `${process.env.GATEWAY_END_POINT}/organisations.info`,
  SUBSCRIPTIONS_SAVE_ROUTE:         `${process.env.GATEWAY_END_POINT}/subscriptions.save`
}
